import { gql, MutationHookOptions, useMutation } from '@apollo/client';

import { UserNotificationPreference } from './useGetUserNotificationPreferences';

export type CreateOrUpdateUserNotificationPreference =
  UserNotificationPreference & {
    CategoryId: string;
  };

type CreateOrUpdateUserNotificationPreferencesInput = {
  preferences: CreateOrUpdateUserNotificationPreference[];
};

type CreateOrUpdateUserNotificationPreferencesOutput = {
  createOrUpdateUserNotificationPreferences: CreateOrUpdateUserNotificationPreference[];
};

const saveUserNotificationPreferences = gql`
  mutation createOrUpdateUserNotificationPreferences(
    $data: CreateOrUpdateUserNotificationPreferencesInput!
  ) {
    createOrUpdateUserNotificationPreferences(data: $data) {
      id
      enabled
      channel
      CategoryId
    }
  }
`;

export const useSaveUserNotificationPreferences = (
  options?: MutationHookOptions<
    CreateOrUpdateUserNotificationPreferencesOutput,
    { data: CreateOrUpdateUserNotificationPreferencesInput }
  >
) =>
  useMutation<
    CreateOrUpdateUserNotificationPreferencesOutput,
    { data: CreateOrUpdateUserNotificationPreferencesInput }
  >(saveUserNotificationPreferences, options);
